import donationChildRoutes from './donation'
import authChildRoutes from './auth'

export default [
  {
    path: '/',
    component: () => import('../views/layouts/default.vue'),
    children: donationChildRoutes('donation', false)
  },
  {
    path: '/embedded-api',
    name: 'public.embedded-api',
    component: () => import('../views/pages/public/embedded-api.vue'),
    meta: {
      authRequired: false
    }
  },
  {
    path: '/auth',
    component: () => import('../views/layouts/auth.vue'),
    children: authChildRoutes('auth', false)
  },
  {
    path: '/donation-flow-not-found',
    name: 'donation.flow-not-found',
    component: () => import('../views/pages/error/flow-not-found.vue')
  },
  {
    path: '/404',
    name: 'error-404',
    component: () => import('../views/pages/error/404.vue'),
    meta: {
      errorPage: true
    }
  },
  {
    path: '/:catchAll(.*)', // Unrecognized path automatically matches 404
    redirect: '/404'
  }
]
